
(() => {
  const MIN_LENGTH = 2;
  const RECENT_KEY = 'search:recent';
  const RECENT_MAX = 5;
  const DEBOUNCE = 250;
  const DESKTOP_FROM = 1001;

  const PRODUCT_LIMIT = 8;
  const MOBILE_VISIBLE = 4;
  const MOBILE_QUERY = '(max-width: 768px)';

  const literal = (q) => {
    const v = String(q || '').trim();
    if (!v || v.endsWith('*') || v.includes('"')) return v;
    return v + '*';
  };

  const recent = {
    read() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
      catch (e) { return []; }
    },
    add(raw) {
      const q = String(raw || '').trim();
      if (q.length < MIN_LENGTH) return;
      const list = [q, ...this.read().filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, RECENT_MAX);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {  }
    },
  };

  const SEARCH_ICON = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 7A6 6 0 1 1 1 7a6 6 0 0 1 12 0Zm-1.41 5.286a7 7 0 1 1 .696-.696.505.505 0 0 1 .068.056l3.5 3.5a.5.5 0 0 1-.708.708l-3.5-3.5a.505.505 0 0 1-.057-.068Z"/></svg>';

  const toChip = (node) => {
    const a = node.querySelector('a[href]');
    const name = node.querySelector('.name')?.textContent.trim();
    if (!a || !name) return null;
    const li = document.createElement('li');
    const link = document.createElement('a');
    link.className = 'sa-search__chip';
    link.href = a.getAttribute('href');
    link.textContent = name;
    li.appendChild(link);
    return li;
  };

  class SearchModal {
    constructor(root) {
      this.root = root;
      this.input = root.querySelector('[data-search-input]');
      this.products = root.querySelector('[data-search-products]');
      this.productsWrap = root.querySelector('[data-search-products-wrap]');
      this.empty = root.querySelector('[data-search-empty]');
      this.recentBox = root.querySelector('[data-search-recent]');
      this.recentList = root.querySelector('[data-search-recent-list]');
      this.allLink = root.querySelector('[data-search-all]');

      this.allToggle = root.querySelector('[data-search-all-toggle]');
      this.placeholder = root.querySelector('.jsSearchPlaceholder, .jsMobSearchPlaceholder');
      this.collections = root.querySelector('[data-search-collections]');
      this.collectionsWrap = root.querySelector('[data-search-collections-wrap]');

      this.count = root.querySelector('[data-search-count]');
      this.more = root.querySelector('[data-search-more]');
      this.fallback = root.querySelector('[data-search-fallback]');

      this.idleProducts = this.products ? this.products.innerHTML : '';

      this.titles = [...root.querySelectorAll('[data-title-found]')].map((el) => ({
        el, idle: el.textContent.trim(), found: el.dataset.titleFound,
      }));
      if (!this.input) return;

      this.input.addEventListener('input', () => {
        this.syncPlaceholder();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.run(), DEBOUNCE);
      });

      this.root.addEventListener('click', (e) => {

        if (e.target.closest('[data-search-cancel]')) {
          clearTimeout(this.timer);
          this.input.value = '';
          this.syncPlaceholder();
          this.run();
          return;
        }
        const chip = e.target.closest('[data-search-query]');
        if (chip) {
          e.preventDefault();
          this.input.value = chip.dataset.searchQuery;
          this.syncPlaceholder();
          this.run();
          this.input.focus();
          return;
        }

        if (e.target.closest('[data-search-try-again]')) {
          e.preventDefault();
          this.input.value = '';
          this.syncPlaceholder();
          this.run();
          this.input.focus();
          return;
        }
        const add = e.target.closest('[data-search-add]');
        if (add) { e.preventDefault(); this.addToCart(add); }
      });

      this.root.addEventListener('submit', (e) => {
        const typed = this.input.value.trim();
        if (typed.length < MIN_LENGTH) { e.preventDefault(); return; }
        recent.add(typed);

        this.input.value = literal(typed);
        setTimeout(() => { this.input.value = typed; }, 0);
      });

      this.renderRecent();
      this.syncPlaceholder();
    }

    syncPlaceholder() {
      if (!this.placeholder) return;
      this.placeholder.style.display = this.input.value ? 'none' : '';
    }

    renderRecent() {
      if (!this.recentBox || !this.recentList) return;
      const items = recent.read();
      this.recentBox.style.display = items.length ? '' : 'none';
      this.recentList.innerHTML = items.map((q) => {
        const safe = q.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        return `<div class="item js_select_item" data-value="${safe}" data-search-query="${safe}">
                  <div class="icon"><i class="iconSvg">${SEARCH_ICON}</i></div>
                  <div class="text"><b>${safe}</b></div>
                </div>`;
      }).join('');
    }

    setState(state) {
      if (this.root.dataset.state !== state) this.root.dataset.state = state;
    }

    async run() {
      const q = this.input.value.trim();
      if (this.allLink) {
        const base = this.allLink.getAttribute('href').split('?')[0];
        this.allLink.setAttribute('href',
          `${base}?q=${encodeURIComponent(literal(q))}&type=product`);
      }

      if (q.length < MIN_LENGTH) {

        this.abort?.abort();
        this.root.removeAttribute('data-loading');

        if (this.products) this.products.innerHTML = this.idleProducts;
        this.productsWrap?.classList.toggle('active', this.idleProducts.trim() !== '');
        if (this.collectionsWrap) {
          this.collectionsWrap.hidden = true;
          this.collectionsWrap.classList.remove('active');
        }
        this.empty?.classList.remove('active');
        if (this.allToggle) this.allToggle.style.display = 'none';
        if (this.count) this.count.textContent = '';
        if (this.more) this.more.hidden = true;
        if (this.fallback) this.fallback.hidden = true;
        this.titles.forEach((t) => { t.el.textContent = t.idle; });
        this.setState('empty');
        this.renderRecent();
        return;
      }

      this.abort?.abort();
      const abort = new AbortController();
      this.abort = abort;
      this.root.setAttribute('data-loading', '');
      try {

        const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        const url = `${root}/search/suggest?q=${encodeURIComponent(literal(q))}`
                  + `&resources[type]=product,collection&resources[limit]=${PRODUCT_LIMIT}`
                  + '&section_id=predictive-search';

        const fullCount = fetch(`${root}/search?q=${encodeURIComponent(literal(q))}&type=product`
          + '&section_id=predictive-search', { signal: abort.signal })
          .then((r) => (r.ok ? r.text() : null));
        fullCount.catch(() => {});
        const res = await fetch(url, { signal: abort.signal });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const cards = doc.querySelectorAll('[data-search-products-list] [data-product-card]');
        this.products.innerHTML = '';
        cards.forEach((c) => this.products.appendChild(c));

        const colls = doc.querySelectorAll('[data-search-collections-list] .searchProductCard');
        if (this.collections) {
          this.collections.innerHTML = '';
          const asChips = this.collections.dataset.render === 'chips';
          colls.forEach((c) => {
            const node = asChips ? toChip(c) : c;
            if (node) this.collections.appendChild(node);
          });
        }

        if (this.collectionsWrap) {
          this.collectionsWrap.hidden = colls.length === 0;
          this.collectionsWrap.classList.toggle('active', colls.length > 0);
        }

        let exact = null;
        try {
          const html = await fullCount;
          if (html) exact = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-count]');
        } catch (err) {
          if (err.name === 'AbortError') throw err;
        }
        const counted = doc.querySelector('[data-search-count]');
        const total = exact ? (Number(exact.dataset.count) || 0) : cards.length;

        const found = cards.length > 0;
        this.productsWrap?.classList.toggle('active', found);

        if (this.allToggle) this.allToggle.style.display = found ? 'block' : 'none';
        this.titles.forEach((t) => { t.el.textContent = found ? t.found : t.idle; });
        this.empty?.classList.toggle('active', !found);
        if (!found) this.showQuery(q);
        if (this.fallback) this.fallback.hidden = found;

        if (!found && total > 0) {
          this.empty?.classList.remove('active');
          if (this.fallback) this.fallback.hidden = true;
        }

        const label = exact || counted;
        if (this.count) this.count.textContent = total > 0 && label ? label.textContent.trim() : '';
        this.setState('results');

        window.Wishlist?.sync?.();
        recent.add(q);
        this.syncMore(total, cards.length);
      } catch (e) {
        if (e.name !== 'AbortError') console.warn('[search]', e);
      } finally {
        if (this.abort === abort) this.root.removeAttribute('data-loading');
      }
    }

    syncMore(total, shown) {
      if (!this.more) return;
      const visible = window.matchMedia(MOBILE_QUERY).matches ? Math.min(shown, MOBILE_VISIBLE) : shown;
      this.more.hidden = !(total > visible);
    }

    showQuery(q) {
      const box = this.empty?.querySelector('[data-search-empty-text]');
      if (!box) return;
      box.textContent = (box.dataset.searchEmptyText || '').replace('@@Q@@', q);
    }

    async addToCart(btn) {
      const id = Number(btn.dataset.id);
      if (!id || btn.disabled) return;
      btn.disabled = true;
      try {
        await window.CartAPI.add([{ id, quantity: 1 }], { source: 'search' });
      } catch (e) {  }
      finally { btn.disabled = false; }
    }
  }

  let pageCollectionsDone = false;
  const fillPageCollections = async () => {

    if (pageCollectionsDone) return;
    const box = document.querySelector('[data-page-collections]');
    if (!box) return;
    pageCollectionsDone = true;
    const q = (box.dataset.query || '').trim();
    if (q.length < MIN_LENGTH) return;
    try {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
      const res = await fetch(`${root}/search/suggest?q=${encodeURIComponent(literal(q))}`
        + '&resources[type]=collection&resources[limit]=6&section_id=predictive-search');
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const cards = doc.querySelectorAll('[data-search-collections-list] .searchProductCard');
      if (!cards.length) return;
      cards.forEach((c) => box.appendChild(c));
      document.querySelectorAll('[data-page-collections-wrap]').forEach((el) => { el.hidden = false; });
    } catch (e) {  }
  };

  const boot = () => {
    document.querySelectorAll('#search-modal, #search-modal-mob').forEach((el) => {
      if (!el.searchModal) el.searchModal = new SearchModal(el);
    });
    fillPageCollections();
  };

  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-search-open]');
    if (!trigger) return;
    e.preventDefault();
    const wide = window.innerWidth >= DESKTOP_FROM;
    const target = document.getElementById(wide ? 'search-modal' : 'search-modal-mob')
      || document.getElementById('search-modal');
    if (!target) return;
    if (target.isOpen) { target.close?.(); return; }

    if (document.querySelector('.jsPcModal.active, .mobileModal.active')) {
      document.querySelector('[data-menu-toggle]')?.click();
    }
    target.open?.(trigger);
    setTimeout(() => target.querySelector('[data-search-input]')?.focus(), 60);
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-menu-toggle]')) return;
    document.querySelectorAll('#search-modal, #search-modal-mob').forEach((el) => {
      if (el.isOpen) el.close();
    });
  }, true);
})();
